import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=028bd292&scoped=true"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028bd292",
  null
  
)

export default component.exports